var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-file-loader',{attrs:{"is-loading":_vm.isLoading,"progress":_vm.loadingProgress,"file":_vm.file,"text":_vm.isFirst ? 'Загрузить файл' : 'Загрузить еще'},on:{"change":_vm.updateFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }